/**
 * File to hold all our VueJS related JavaScript
 */

/* Vue Stuff ******************************************************************/
window.Vue = require('vue').default;

// setup our plugins
require('./vue-plugins');
// include our global vue filters
require('./vue-filters');
// include our global mixins
require('./vue-mixins');

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./components/', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('customer', require('./components/Customer.vue').default); // the above two make with naiming converntion work auto-map-ly

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// LWK moved to vue-{}end files
// const app = new Vue({
//     el: '#app',
// });
